import { automaticThoughtIdType } from "api/conceptApi";
import { seqPostfix_ko } from "data/prefixData";
import { getRawTaskTitleFromTaskId, getTaskIdFromTaskKey } from "logic/logics";
import { useTranslation } from "react-i18next";

export default function useGetTaskTitleFromTaskKey(
  taskKey: string,
  ignorePostfix: boolean = false
) {
  const taskId = getTaskIdFromTaskKey(taskKey);
  const { t } = useTranslation("translation", {
    keyPrefix: "task.title",
  });

  // "90-1-A_1@1" => "월요일의 명상 훈련 (1)"
  if (taskId.startsWith("90-1-A")) {
    const weekNumber = Number(taskId.split("@")[1]);
    const weekdayMap = [
      "월",
      "화",
      "수",
      "목",
      "금",
      "토",
      "일",
    ];
    const weekday = weekdayMap[weekNumber - 1] || "";
    const base = `${weekday}요일의 명상 훈련`;

    if (taskId.includes("_")) {
      const seq = Number(taskId.split("_")[1].split("@")[0]);
      return `${base} (${seq})`;
    }
    return base;
  }

  const title =
    taskKey === "dashboard"
      ? "대시보드"
      : taskKey === "thoughtmap"
        ? "생각 그물"
        : taskKey === "valueCompass"
          ? "가치 나침반"
          : taskKey === "progress"
            ? "진행 상황"
            : taskKey === "payment"
              ? "월 이용권"
              : // "월 구독"
                taskKey === "chat"
                ? "채팅"
                : getRawTaskTitleFromTaskId(taskId);

  if (ignorePostfix) {
    return title;
  }

  const N = taskId.split("#")[1] as automaticThoughtIdType;
  const M = taskId.split("#")[2] as automaticThoughtIdType;

  const postfix = taskId.includes("_")
    ? ` (${taskId.split("_")[1].split("#")[0]})`
    : "";

  if (M || N) {
    return `${t(title || "", {
      N: `${seqPostfix_ko[N]} `, //행동활성화
      M: M, //행동활성화
      n: N, //행동실험
    })}${postfix}`;
  }
  return `${title}${postfix}`;
}
